import { Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import ModalPanel from './ModalPanel';
const zSpaceCoef = {
    'laptop': 1.52,
    'aio': 1,
};
export default class DetermineZSpaceDevice extends ViewerModule {
    constructor() {
        super();
        if (!Viewer.zSpace)
            return;
        window['d'] = this;
        this.zSpaceDeviceType = localStorage.getItem('ZSpaceDeviceType');
        if (this.zSpaceDeviceType === 'laptop')
            document.body.classList.add('zspace-laptop');
        // @ts-ignore
        if (['laptop', 'aio'].includes(this.zSpaceDeviceType)) {
            this.viewerScaleCoef = zSpaceCoef[this.zSpaceDeviceType];
        }
        else {
            this.init();
        }
    }
    init() {
        this.determineModal = new ModalPanel(true);
        this.determineModal.uiObject.scale.multiplyScalar(0.14);
        this.addObject(this.determineModal);
        this.determineModal.init('Specify your zSpace device type', 'Laptop', 'AIO');
        this.determineModal.on('ok', () => {
            this.determineModal.uiObject.visible = false;
            this.zSpaceDeviceType = 'laptop';
            localStorage.setItem('ZSpaceDeviceType', this.zSpaceDeviceType);
            this.viewerScaleCoef = zSpaceCoef[this.zSpaceDeviceType];
            // this.inZSpace();
            location.reload();
        });
        this.determineModal.on('exit', () => {
            this.determineModal.uiObject.visible = false;
            this.zSpaceDeviceType = 'aio';
            localStorage.setItem('ZSpaceDeviceType', this.zSpaceDeviceType);
            this.viewerScaleCoef = zSpaceCoef[this.zSpaceDeviceType];
            this.inNotZSpace();
            // this.inZSpace();
        });
        if (Viewer.controls.zController) {
            this.inZSpace();
        }
        else {
            this.inNotZSpace();
        }
        Viewer.on('goToZSpace', () => {
            setTimeout(() => this.inZSpace(), 10);
        });
        Viewer.on('goFromZSpace', () => {
            this.inNotZSpace();
        });
        Viewer.on('update', () => {
            if (Viewer.controls.zController) {
                this.determineModal.uiObject.position.copy(Viewer.controls.zController.position);
                this.determineModal.uiObject.quaternion.copy(Viewer.zSpace.zController.quaternion);
            }
        });
    }
    inZSpace() {
        Viewer.scene.add(this.determineModal.uiObject);
        this.determineModal.uiObject.scale.set(2, 2, 2);
        const viewerScaleCoef = (this.viewerScaleCoef) ? this.viewerScaleCoef : 1;
        // @ts-ignore
        if (Viewer.controls.zController && Viewer.controls.zController._viewerScale) {
            // @ts-ignore
            Viewer.controls.zController.setViewerScale(Viewer.controls.zController._viewerScale * viewerScaleCoef);
        }
    }
    inNotZSpace() {
        Viewer.camera.add(this.determineModal.uiObject);
        this.determineModal.uiObject.position.set(0, 0, -0.2);
        this.determineModal.uiObject.scale.set(0.14, 0.14, 0.14);
    }
}
// const DetermineZSpaceDevice = new DetermineZSpaceDeviceClass();
// export default DetermineZSpaceDevice;
